import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';

import { AppRoutingModule } from './app-routing.module';
import { MaterialModule } from './material/material.module';
import { SharedModule } from './shared/shared.module';
import { SkeletonLoaderComponent } from './shared/components/skeleton-loader/skeleton-loader.component';

import { AppComponent } from './app';

import { HeaderComponent } from './layouts/header/header.component';
import { SidebarComponent } from './layouts/sidebar/sidebar.component';

import { LoginComponent } from './features/auth/login/login.component';
import { DashboardComponent } from './features/dashboard/dashboard.component';
import { DepartmentsComponent } from './features/departments/departments.component';
import { DesignationsComponent } from './features/designations/designations.component';
import { MasterDataComponent } from './features/master-data/master-data.component';
import { ProfileComponent } from './features/profile/profile.component';
import { SettingsComponent } from './features/settings/settings.component';
import { RoleManagementComponent } from './features/role-management/role-management.component';
import { RosterComponent } from './features/roster/roster.component';
import { ChangeRequestsComponent } from './features/change-requests/change-requests.component';
import { OverviewComponent } from './features/overview/overview.component';
import { Shifts } from './features/shifts/shifts';
import { ExceptionsComponent } from './features/master-data/exceptions/exceptions.component';
import { EmailTemplatesComponent } from './features/email-templates/email-templates.component';
import { ToastComponent } from './shared/components/toast/toast.component';
import { PeopleHubComponent } from './features/people/people-hub.component';

import { RolesComponent } from './features/admin/roles/roles.component';
import { ManagerDashboardComponent } from './features/dashboard/manager-dashboard/manager-dashboard.component';
import { UnauthorisedComponent } from './features/unauthorised/unauthorised.component';

import { RequestInterceptor } from './core/interceptors/request.interceptor';
import { Chatbot } from '@features/chatbot/chatbot.component';
import { PolicyConsentComponent } from './layouts/policy-consent/policy-consent.component';
import { EmployeeFormDrawerComponent } from './shared/components/employee-form-drawer/employee-form-drawer.component';
import { AnnouncementWidgetComponent } from './shared/components/announcement-widget/announcement-widget.component';
import { PulseWidgetComponent } from './shared/components/pulse-widget/pulse-widget.component';
import { OrgStructureComponent } from './features/org-structure/org-structure.component';

@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    SidebarComponent,
    LoginComponent,
    DashboardComponent,
    DepartmentsComponent,
    DesignationsComponent,
    MasterDataComponent,
    ProfileComponent,
    SettingsComponent,
    RoleManagementComponent,
    RosterComponent,
    ChangeRequestsComponent,
    OverviewComponent,
    Shifts,
    ExceptionsComponent,
    EmailTemplatesComponent,
    ToastComponent,
    PeopleHubComponent,
    OrgStructureComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    MaterialModule,
    SharedModule,
    SkeletonLoaderComponent,
    DragDropModule,
    RolesComponent,
    ManagerDashboardComponent,
    UnauthorisedComponent,
    Chatbot,
    PolicyConsentComponent,
    EmployeeFormDrawerComponent,
    AnnouncementWidgetComponent,
    PulseWidgetComponent
  ],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: RequestInterceptor, multi: true }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
